import { render, staticRenderFns } from "./PatientsFormGuardians.vue?vue&type=template&id=c142f676&"
import script from "./PatientsFormGuardians.vue?vue&type=script&lang=js&"
export * from "./PatientsFormGuardians.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports